const readImageAsDataUrl = (imageFile: Blob): Promise<string> =>
  new Promise(resolve => {
    const reader = new FileReader();
    reader.onload = e => resolve(e.target?.result as string);
    reader.readAsDataURL(imageFile);
  });

export default readImageAsDataUrl;
